import { gql } from "@apollo/client"

export const DASHBOARD_PGM_GRADUATE_QUERY = gql`
  query DashboardPgmGraduate {
    currentPerson {
      id
      pgmGraduate
    }
  }
`

export const TERMINATED_MEMBER_APPLICATION_ELIGIBILITY_QUERY = gql`
  query TerminatedMemberApplicationEligibility {
    memberApplicationEligibility {
      eligible
      reinstatementType
    }
  }
`

export const TERMINATED_MEMBER_APPLICATIONS_QUERY = gql`
  query TerminatedMemberApplications {
    membershipApplications(applicationType: member) {
      id
      applicationType
      status
      registrationStatus
      reinstatementType
      electedAt
      updatedAt
    }
  }
`

export const MEMBER_APPLY_PATH_QUERY = gql`
  query MemberApplyPath {
    memberApplicationEligibility {
      eligible
      eligibilityPath
    }
  }
`

export const MEMBER_APPLICATION_ELIGIBILITY_QUERY = gql`
  query MemberApplicationEligibility {
    memberApplicationEligibility {
      eligible
      blockingReasons
      playingAbilityTest {
        complete
        expired
      }
      backgroundCheck {
        complete
      }
      age {
        complete
      }
      acceptableProgress {
        complete
        expired
      }
      pgmLevels {
        complete
      }
      experienceCredits {
        total
        threshold
        complete
        educationCredits
        employmentCredits
      }
      goodStanding {
        complete
      }
      activelyEmployed {
        complete
      }
    }
  }
`
